import React from 'react';
import stadium from "../Photo/stadium.jpg"
const Header = () => {
    const headerStyle={
        color:"yellow",
        textAlign:"center",
        justifyContent:"center",
        border:"1px solid navy",
        backgroundImage:`url(${stadium})`,
        backgroundRepeat: 'no-repeat',
        width: '100%',
        height: '450px',
        lineHeight:"100%",
        display:"flex",
        backgroundColor:"lightgray",
    }
    return (
        <div style={headerStyle}>
            <div style={{display:"flex",justifyContent:"center",marginTop: "200px"}}>            
            <h1>Sports Mania</h1>             
            </div>
        </div>
    );
};

export default Header;